<kiwi-tabs class="_whiteTabs" *ngIf="tabs" [tabs]="tabs | async"></kiwi-tabs>
<router-outlet (activate)="onRouterActivate($event)"></router-outlet>
